import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assistant-cell-boolean',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (truthy()) {
      <rt-icon name="check" size="small" class="yes" />
    } @else {
      <span class="no">—</span>
    }
  `,
  styleUrl: './cell-boolean.component.less',
})
export class AssistantCellBooleanComponent {
  public static readonly NgInputs = [<const>'value'];

  protected readonly truthy = computed(() => {
    const v = this.value();
    if (typeof v === 'boolean') return v;
    if (typeof v === 'number') return v !== 0;
    if (typeof v === 'string') return /^(true|yes|1|y)$/i.test(v.trim());
    return false;
  });

  public readonly value = input<unknown>();
}
